import { type Getter, type Setter } from 'jotai'

import { logAppError } from 'Helpers/logger'
import { searchFilters } from 'Pages/unifiedFiltersListPage/callbacks/filters'
import {
  deleteFilter,
  getEntitiesUsingFilter,
} from 'Pages/unifiedFiltersListPage/services/services'
import { notifyFilterInUse } from 'Pages/unifiedFiltersListPage/services/toasts'
import { modalDeleteAtom } from 'Pages/unifiedFiltersListPage/state/state'
import { errorUpdater, loaderUpdater, pageState } from 'State/page'
import { notifySuccess } from '../../../helpers/notifyToast'

export const modalDeleteOpenCallback = async (
  _: Getter,
  set: Setter,
  idFilter: number,
): Promise<void> => {
  console.log('### idFilter', idFilter)
  set(pageState, loaderUpdater(true))
  try {
    const entities = await getEntitiesUsingFilter(idFilter)
    if (entities.length === 0) {
      set(modalDeleteAtom, {
        show: true,
        idFilter,
      })
    } else {
      notifyFilterInUse(entities)
    }
  } catch (error) {
    console.error('### error', error)

    logAppError({
      Component: 'UnifiedFiltersListPage',
      Method: 'modalDeleteOpenCallback',
      appError: error instanceof Error ? error : undefined,
    })

    set(pageState, errorUpdater)
  }

  set(pageState, loaderUpdater(false))
}

export const modalDeleteCloseCallback = (_: Getter, set: Setter): void => {
  set(modalDeleteAtom, {
    show: false,
  })
}

export const modalDeleteConfirmCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  const state = get(modalDeleteAtom)

  if (state.show && state.idFilter > 0) {
    set(pageState, loaderUpdater(true))

    try {
      await deleteFilter(state.idFilter)
      await searchFilters(get, set)
      notifySuccess('Load.Alerts.SuccessDelete')
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'UnifiedFiltersListPage',
        Method: 'modalDeleteConfirmCallback',
        appError: error instanceof Error ? error : undefined,
      })

      set(pageState, errorUpdater)
    }

    set(pageState, loaderUpdater(false))
    set(modalDeleteAtom, { show: false })
  }
}
